import {
  getBaseReport,
  downReport,
  getBaseReportTruck,
  getTruckList,
} from "@/views/ifta/api/report";
import uniqBy from "lodash/uniqBy"

const state = {
  namespaced: true,
  state: {
    abridge: [
      {
        full: "Alabama",
        shrink: "AL",
        country: "US",
      },
      {
        full: "Alaska",
        shrink: "AK",
        country: "US",
      },
      {
        full: "Arizona",
        shrink: "AZ",
        country: "US",
      },
      {
        full: "Arkansas",
        shrink: "AR",
        country: "US",
      },
      {
        full: "California",
        shrink: "CA",
        country: "US",
      },
      {
        full: "Colorado",
        shrink: "CO",
        country: "US",
      },
      {
        full: "Connecticut",
        shrink: "CT",
        country: "US",
      },
      {
        full: "Delaware",
        shrink: "DE",
        country: "US",
      },
      {
        full: "Florida",
        shrink: "FL",
        country: "US",
      },
      {
        full: "Georgia",
        shrink: "GA",
        country: "US",
      },
      {
        full: "Hawaii",
        shrink: "HI",
        country: "US",
      },
      {
        full: "Idaho",
        shrink: "ID",
        country: "US",
      },
      {
        full: "Illinois",
        shrink: "IL",
        country: "US",
      },
      {
        full: "Indiana",
        shrink: "IN",
        country: "US",
      },
      {
        full: "Iowa",
        shrink: "IA",
        country: "US",
      },
      {
        full: "Kansas",
        shrink: "KS",
        country: "US",
      },
      {
        full: "Kentucky",
        shrink: "KY",
        country: "US",
      },
      {
        full: "Louisiana",
        shrink: "LA",
        country: "US",
      },
      {
        full: "Maine",
        shrink: "ME",
        country: "US",
      },
      {
        full: "Maryland",
        shrink: "MD",
        country: "US",
      },
      {
        full: "Massachusetts",
        shrink: "MA",
        country: "US",
      },
      {
        full: "Michigan",
        shrink: "MI",
        country: "US",
      },
      {
        full: "Minnesota",
        shrink: "MN",
        country: "US",
      },
      {
        full: "Mississippi",
        shrink: "MS",
        country: "US",
      },
      {
        full: "Missouri",
        shrink: "MO",
        country: "US",
      },
      {
        full: "Montana",
        shrink: "MT",
        country: "US",
      },
      {
        full: "Nebraska",
        shrink: "NE",
        country: "US",
      },
      {
        full: "Nevada",
        shrink: "NV",
        country: "US",
      },
      {
        full: "New Hampshire",
        shrink: "NH",
        country: "US",
      },
      {
        full: "New Jersey",
        shrink: "NJ",
        country: "US",
      },
      {
        full: "New Mexico",
        shrink: "NM",
        country: "US",
      },
      {
        full: "New York",
        shrink: "NY",
        country: "US",
      },
      {
        full: "North Carolina",
        shrink: "NC",
        country: "US",
      },
      {
        full: "North Dakota",
        shrink: "ND",
        country: "US",
      },
      {
        full: "Ohio",
        shrink: "OH",
        country: "US",
      },
      {
        full: "Oklahoma",
        shrink: "OK",
        country: "US",
      },
      {
        full: "Oregon",
        shrink: "OR",
        country: "US",
      },
      {
        full: "Pennsylvania",
        shrink: "PA",
        country: "US",
      },
      {
        full: "Rhode Island",
        shrink: "RI",
        country: "US",
      },
      {
        full: "South Carolina",
        shrink: "SC",
        country: "US",
      },
      {
        full: "South Dakota",
        shrink: "SD",
        country: "US",
      },
      {
        full: "Tennessee",
        shrink: "TN",
        country: "US",
      },
      {
        full: "Texas",
        shrink: "TX",
        country: "US",
      },
      {
        full: "Utah",
        shrink: "UT",
        country: "US",
      },
      {
        full: "Vermont",
        shrink: "VT",
        country: "US",
      },
      {
        full: "Virginia",
        shrink: "VA",
        country: "US",
      },
      {
        full: "Washington",
        shrink: "WA",
        country: "US",
      },
      {
        full: "West Virginia",
        shrink: "WV",
        country: "US",
      },
      {
        full: "Wisconsin",
        shrink: "WI",
        country: "US",
      },
      {
        full: "Wyoming",
        shrink: "WY",
        country: "US",
      },
      {
        full: "Alberta",
        shrink: "AB",
        country: "CAN",
      },
      {
        full: "British Columbia",
        shrink: "BC",
        country: "CAN",
      },
      {
        full: "Manitoba",
        shrink: "MB",
        country: "CAN",
      },
      {
        full: "New Brunswick",
        shrink: "NB",
        country: "CAN",
      },
      {
        full: "Nova Scotia",
        shrink: "NS",
        country: "CAN",
      },
      {
        full: "Newfoundland and Labrador",
        shrink: "NL",
        country: "CAN",
      },
      {
        full: "Ontario",
        shrink: "ON",
        country: "CAN",
      },
      {
        full: "Prince Edward Island",
        shrink: "PE",
        country: "CAN",
      },
      {
        full: "Quebec",
        shrink: "QC",
        country: "CAN",
      },
      {
        full: "Saskatchewan",
        shrink: "SK",
        country: "CAN",
      },
      {
        full: "Yukon",
        shrink: "YT",
        country: "CAN"
      },
      {
        full: "Northwest Territories",
        shrink: "NT",
        country: "CAN",
      },
      {
        full: "Nunavut",
        shrink: "NU",
        country: "CAN"
      }
    ],
    reportYear: null,
    reportQuater: null,
    truckList: [],
    selectTruckList: [],
    baseReport: {},
    notFinishedTruck: [],
    truckList2: [],
    setttingInfo: {},
    reportLoading: false,
  },
  mutations: {
    SET_TRUCKLIST(state, payload) {
      state.truckList = payload.sort((x, y) => {
        const xTruckNo = x.truckNo || ''
        const yTruckNo = y.truckNo || ''
        return (xTruckNo[0] || 'z').charCodeAt() - (yTruckNo[0] || 'z').charCodeAt()
      });
    },
    SET_TRUCKLIST2(state, payload) {
      state.truckList2 = payload.map(item => ({ ...item }));
    },
    SET_SELECTTRUCKLIST(state, payload) {
      state.selectTruckList = payload;
    },
    SET_BASEREPORT(state, payload) {
      state.baseReport = Object.assign({}, payload);
    },
    SET_REPORTYEAR(state, payload) {
      state.reportYear = Number(payload);
    },
    SET_REPORTQUATER(state, payload) {
      state.reportQuater = Number(payload);
    },
    SET_NOTFINISHEDTRUCK(state, payload) {
      state.notFinishedTruck = payload;
    },
    SET_SETTINGINFO(state, settingInfo) {
      state.setttingInfo = settingInfo
    },
    SET_REPORTLOADING(state, payload) {
      state.reportLoading = payload
    },
  },
  actions: {
    async getTruck({ commit }) {
      await getTruckList().then(res => {
        const data = res.data
        commit('SET_TRUCKLIST2', data);
      })
    },
    async getBaseReportTrucks({ commit, state }) {
      /**
       * @param {*} param0
       */
      if (state.reportQuater && state.reportYear) {
        const res = await getBaseReportTruck({
          quatar: state.reportQuater,
          year: state.reportYear,
        });
        commit("SET_TRUCKLIST", uniqBy(res.data.map(item => ({...item, id: item.truckId})), 'id'));
      }
    },
    /**
     * @param {*} param0
     */
    async getTruckInfo({ state, commit }) {
      try {
        const res = await getBaseReport(
          {
            month: state.reportQuater,
            year: state.reportYear,
          },
          state.selectTruckList.map((item) => item.truckId)
        );
        commit("SET_BASEREPORT", { ...res.data, createDate: Date.now() });
        if (res.data.notFinishedTruck) {
          commit("SET_NOTFINISHEDTRUCK",  res.data.notFinishedTruck);
        }
      } catch(err) {
        console.log(err)
      }
    },
    /**
     * @param {*} param0
     * @param {*} payload
     */
    async downReportFile({ state }, payload) {
      if (payload.reportId === null && state.baseReport.reportId === null)
        return;
      const res = await downReport({
        reportId: payload.reportId
          ? payload.reportId
          : Number(state.baseReport.reportId),
        type: payload.type,
      });

      const url = window.URL.createObjectURL(
        new Blob([res.data], {
          type:
            payload.type === "pdf"
              ? "application/pdf;charset-UTF-8"
              : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
        })
      );
      if (payload.openWidth === "download") {
        const a = document.createElement("a");
        a.href = url;
        a.download = "iftaReport.pdf";
        a.download = `iftaReport.${payload.type === "pdf" ? "pdf" : "xlsx"}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } else {
        window.open(url, "__blank");
      }
    },
    setSettingInfo({ commit }, data ) {
      console.log(data,'422');
      commit("SET_SETTINGINFO",  data);
    }
  },
};

export default state;
